import { JsonSchemaValidator } from "@common/json-schema-validator";

export class RoomsListRequestDTO {
  private static validation = JsonSchemaValidator.compile(
    RoomsListRequestDTO.validationSchema()
  );

  constructor(readonly data: RoomsListRequest) {
    JsonSchemaValidator.assert(RoomsListRequestDTO.validation, data);
  }

  private static validationSchema() {
    return {
      type: "object",
      required: [],
      properties: {},
      additionalProperties: false
    };
  }
}

// eslint-disable-next-line @typescript-eslint/no-empty-interface
interface RoomsListRequest {}
